import { ISelectData } from 'components/atoms/SelectComponent';

import { ETypUdalosti } from 'enums/akcionarKorpAkce/typUdalosti';

export const novaOznameni: ISelectData[] = [
    {
        value: ETypUdalosti.VH,
        labelcz: 'SRD_NOVA_OZNAMENI_HROMADA'
    },
    {
        value: ETypUdalosti.VYPIS,
        labelcz: 'SRD_NOVA_OZNAMENI_ZADOST'
    },
    {
        value: ETypUdalosti.JINA,
        labelcz: 'SRD_NOVA_OZNAMENI_JINA'
    }
];
